export default __webpack_public_path__ + "static/media/mintMobileBg.6f52b873.mp4";